<div class="container" *ngIf="logic" #conditionELement>
    <div #analogInput class="analog-channel-input channel-input-container" *ngIf="!isDigital" (click)="openDialog()">
        <input
            class="channel-input"
            type="text"
            [placeholder]="'matrix.dialog.input.analog.placeholder' | translate"
            (ngModelChange)="anaglogTextChange($event)"
            [(ngModel)]="analogText"
            [class.error]="logic.isError"
            (focus)="inputFocus()"
            (blur)="analogInputBlur()"
            [maxlength]="20" />
        <span class="unit">{{ logic?.channel?.opsData.measurementUnit }}</span>
        <div class="channel-dialog" [class.show]="isShowDialog" [style.top]="optionsTop" [style.left]="optionsLeft">
            <div
                class="digital-string-item"
                *ngFor="let analogLogic of analogLogicList"
                (mousedown)="setAnalogLogic(analogLogic)">
                {{ analogLogic }}
            </div>
        </div>
    </div>
    <div #digitalInput class="digital-channel-input channel-input-container" *ngIf="isDigital" (click)="openDialog()">
        <input
            class="channel-input"
            type="text"
            [placeholder]="'matrix.dialog.input.digital.placeholder' | translate"
            [(ngModel)]="digitalString"
            readonly
            (focus)="inputFocus()"
            (blur)="digitalInputBlur()" />
        <mat-icon class="icon arrow" svgIcon="dropdown-arrow"></mat-icon>
        <div class="channel-dialog" [class.show]="isShowDialog" [style.top]="optionsTop" [style.left]="optionsLeft">
            <div
                class="digital-string-item"
                *ngFor="let digitalString of digitalStringList"
                (click)="setDigitalString(digitalString)">
                {{ digitalString }}
            </div>
        </div>
    </div>
</div>

<div class="container" *ngIf="!logic">
    <div class="analog-channel-input channel-input-container"></div>
</div>
